import { CommonModule } from '@angular/common';
import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import * as i0 from "@angular/core";
export class RefreshRequiredModalModule {
}
RefreshRequiredModalModule.ɵfac = function RefreshRequiredModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RefreshRequiredModalModule)(); };
RefreshRequiredModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: RefreshRequiredModalModule });
RefreshRequiredModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, ModalBaseModule] });
